import { communicationLocaleKeysOptions } from "@faire/retailer-visitor-shared/consts/LANGUAGE";
import { DEFAULT_LOCALE_KEY } from "@faire/web/common/consts/DEFAULT_LOCALE";
import { localeKeyToLocaleString } from "@faire/web/common/localization/localeKeyToLocaleString";
import { IOption } from "@faire/web/slate/Dropdown";
import { useMutation as useListAvailableLocales } from "@faire/web-api--source/endpoints/www/api/v2/addresses/available-locales/post-hooks";
import { IListAvailableLocalesRequest } from "@faire/web-api--source/faire/geo/IListAvailableLocalesRequest";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import flatten from "lodash/flatten";
import { useEffect, useMemo } from "react";

export const useLanguageOptions = (country: string) => {
  const { mutate, data } = useListAvailableLocales();

  useEffect(() => {
    mutate([
      IListAvailableLocalesRequest.build({
        countries: [country as keyof typeof ISO3166Alpha3],
      }),
    ]);
  }, [country, mutate]);

  return useMemo(() => {
    if (!data?.available_locales) {
      return communicationLocaleKeysOptions();
    }

    const options: IOption[] = flatten(
      data.available_locales.map((availableLocale) => {
        return availableLocale.locales.map((locale) => {
          const localeKey = locale.locale_key ?? DEFAULT_LOCALE_KEY;

          return {
            label: locale.localized_name ?? "",
            value: localeKeyToLocaleString({
              localeKey,
              dashFormat: false,
            }),
          };
        });
      })
    );

    return options;
  }, [data]);
};
